(() => {
  'use strict';

  if (window.JJCategoryHighlightsLoaded) return;
  window.JJCategoryHighlightsLoaded = true;

  const SECTION = '[data-jj-category-section]';
  const TAB = '[data-jj-category-tab]';
  const PANEL = '[data-jj-category-panel]';
  const MORE = '[data-jj-category-more]';

  function activate(section, tab, moveFocus = false) {
    if (!section || !tab) return;

    const targetId = tab.getAttribute('aria-controls');
    if (!targetId) return;

    section.querySelectorAll(TAB).forEach((item) => {
      const selected = item === tab;
      item.setAttribute('aria-selected', selected ? 'true' : 'false');
      item.tabIndex = selected ? 0 : -1;
    });

    section.querySelectorAll(PANEL).forEach((panel) => {
      const selected = panel.id === targetId;
      panel.hidden = !selected;
      panel.setAttribute('aria-hidden', selected ? 'false' : 'true');
    });

    const more = section.querySelector(MORE);
    if (more) {
      const url = tab.dataset.collectionUrl;
      if (url) {
        more.href = url;
        more.hidden = false;
      } else {
        more.hidden = true;
      }
    }

    if (moveFocus) tab.focus({ preventScroll: true });

    // Keep the selected chip visible horizontally without ever changing the page's vertical scroll.
    // scrollIntoView() can still move the document vertically on some mobile browsers, even with
    // block: 'nearest', so only the tab rail itself is scrolled here.
    const rail = section.querySelector('.jj-category-highlights__tabs');
    if (rail) {
      const railRect = rail.getBoundingClientRect();
      const tabRect = tab.getBoundingClientRect();
      let delta = 0;

      if (tabRect.left < railRect.left) {
        delta = tabRect.left - railRect.left - 8;
      } else if (tabRect.right > railRect.right) {
        delta = tabRect.right - railRect.right + 8;
      }

      if (delta) rail.scrollBy({ left: delta, behavior: 'smooth' });
    }

    section.dispatchEvent(new CustomEvent('jj:category:change', {
      bubbles: true,
      detail: {
        collectionHandle: tab.dataset.collectionHandle || '',
        collectionUrl: tab.dataset.collectionUrl || ''
      }
    }));
  }

  function initialize(section) {
    if (!section || section.dataset.jjCategoryReady === 'true') return;
    section.dataset.jjCategoryReady = 'true';

    const tabs = Array.from(section.querySelectorAll(TAB));
    if (!tabs.length) return;

    const selected = tabs.find((tab) => tab.getAttribute('aria-selected') === 'true') || tabs[0];
    activate(section, selected, false);
  }

  document.addEventListener('click', (event) => {
    const tab = event.target.closest?.(TAB);
    if (!tab) return;
    const section = tab.closest(SECTION);
    if (!section) return;
    event.preventDefault();
    activate(section, tab, false);
  });

  document.addEventListener('keydown', (event) => {
    const tab = event.target.closest?.(TAB);
    if (!tab) return;

    const section = tab.closest(SECTION);
    if (!section) return;

    const tabs = Array.from(section.querySelectorAll(TAB));
    const current = tabs.indexOf(tab);
    if (current < 0) return;

    let next = current;
    if (event.key === 'ArrowRight') next = (current + 1) % tabs.length;
    else if (event.key === 'ArrowLeft') next = (current - 1 + tabs.length) % tabs.length;
    else if (event.key === 'Home') next = 0;
    else if (event.key === 'End') next = tabs.length - 1;
    else return;

    event.preventDefault();
    activate(section, tabs[next], true);
  });

  function initializeAll(root = document) {
    if (root.matches?.(SECTION)) initialize(root);
    root.querySelectorAll?.(SECTION).forEach(initialize);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initializeAll());
  } else {
    initializeAll();
  }

  document.addEventListener('shopify:section:load', (event) => initializeAll(event.target));
})();
